import React, { useEffect, useState } from 'react';
import { Card, CardContent, CircularProgress, Grid, Typography, List, Stack } from "@mui/material";
import { Search, SearchIconWrapper, StyledInputBase } from "app/shared/SearchGlobal/style";
import _ from "lodash";
import Div from "@jumbo/shared/Div";
import surveyServices from "app/services/survey-services";
import SearchIcon from "@mui/icons-material/Search";
// import UserEditModal from './UserEditModal';


const SurveysIndex = () => {
    // const Swal = useSwalWrapper();
    // const theme = useTheme();
    const [currentPage, setCurrentPage] = useState(1)
    const [totalPages, setTotalPages] = useState(1)
    const [recordsList, setRecordsList] = useState([])
    const [searchQuery, setSearchQuery] = useState('')
    const [listLoading, setListLoading] = useState(false)
    const [currentUserId, setCurrentUserId] = useState(null)
    const [openRecordEditModal, setOpenRecordEditModal] = useState(false)

    useEffect(() => {
        if(listLoading){
            loadRecords()
        }
    }, [listLoading])

    useEffect(() => {
        setListLoading(true)
    }, [])

    const buildRecordParams = () => {
        let par = []
        
        par.push(`include=companies`)

        par = _.join(par, '&')

        return `?${par}`;
    }

    const loadRecords = () => {
        surveyServices.getQuestions(buildRecordParams())
            .then(resp => {
                setRecordsList(resp)
                // setTotalPages(resp.meta.total_pages)
            })
            .catch(function (error) {})
            .finally(() => {
                setListLoading(false)
            });
    }

    const handleSearchQueryChange = (newVal) => {
        setCurrentPage(1)
        setSearchQuery(newVal)
        setListLoading(true)
    }

    const handleUserChange = (newUser) => {
        setRecordsList(_.map(recordsList, (u) => { return u.id == newUser.id ? newUser : u }))
    }

    const debounceSearchQueryChange = _.debounce(handleSearchQueryChange, 450)

    const renderRecordsList = () => {
        if(recordsList){
            return (
                <React.Fragment>
                    {/* <UserEditModal userID={currentUserId} isOpen={openRecordEditModal} onClose={(changed, userOutput) => { setOpenRecordEditModal(false) }} onUserChange={handleUserChange} /> */}
                    <List disablePadding>
                        {_.map(recordsList, (u, i) => {
                            return (
                                <React.Fragment key={u.id}>
                                    <Card sx={{mb: 2}}>
                                        <CardContent sx={{display: 'flex'}}>
                                            <Grid container spacing={5}>
                                                <Grid item xs={12} md={4}>
                                                    <Stack
                                                        direction="column"
                                                        justifyContent="start"
                                                        alignItems="left"
                                                        spacing={0.5}>
                                                        <Typography variant={"overline"} color="primary">{u.title}</Typography>
                                                        {/* <Typography variant={"button"} color="primary">{u.first_name} {u.last_name}</Typography> */}
                                                    </Stack>
                                                </Grid>
                                                <Grid item xs={12} md={4}>
                                                </Grid>
                                                <Grid item xs={12} md={3} style={{height: '100%'}}>
                                                </Grid>
                                                <Grid item xs={12} md={1} style={{height: '100%'}}>
                                                    {/* <IconButton onClick={() => { setCurrentUserId(u.id); setOpenRecordEditModal(true) }}>
                                                        <EditOutlinedIcon />
                                                    </IconButton> */}
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                </React.Fragment>
                            )
                        })}
                    </List>
                </React.Fragment>
            )
        } else {
            return(
                <Typography>
                    No se encontraron datos
                </Typography>
            )
        }
    }
    
    return (
        <div>
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                spacing={3}
                sx={{mb: 2}}>
                <Typography variant="h2">Encuestas</Typography>
                <Stack
                    direction="row"
                    alignItems="center"
                    spacing={3}>
                    
                    <Search sx={{maxWidth: { sm: 200, md: 350 }}}>
                        <SearchIconWrapper>
                            <SearchIcon/>
                        </SearchIconWrapper>

                        <StyledInputBase
                            placeholder="Buscar"
                            inputProps={{'aria-label': 'search'}}
                            sx={{background: 'white'}}
                            onChange={(e) => {
                                debounceSearchQueryChange(e.target.value)
                            }}
                            onKeyDown={(e) => {
                                if (e.key == 'Enter') {
                                    handleSearchQueryChange(e.target.value)
                                }
                            }}
                        />
                    </Search>
                </Stack>
            </Stack>

            <Div sx={{display: listLoading ? 'block' : 'none', textAlign: 'center', my: 5}}>
                <CircularProgress color="warning"/>
            </Div>
            <Grid container spacing={3.75}>
                <Grid item xs={12}>
                    {renderRecordsList()}
                </Grid>
            </Grid>
        </div>
    );
};

export default SurveysIndex;